export default __webpack_public_path__ + "static/media/corporate11.ddf2d1d7.webp";